<section class="playground">
  <h2 class="playground__heading">Avatar</h2>
  <p class="playground__hint">
    <code>common-avatar</code> — imagen circular o iniciales de fallback, 3 tamaños.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>imageUrl (opcional)</span>
        <input type="text" [(ngModel)]="imageUrl" placeholder="https://..." />
      </label>

      <label class="playground__field">
        <span>initials (fallback si no hay imagen)</span>
        <input type="text" [(ngModel)]="initials" maxlength="2" placeholder="JD" />
      </label>

      <label class="playground__field">
        <span>size</span>
        <select [(ngModel)]="size">
          <option *ngFor="let s of sizes" [value]="s">{{ s }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>backgroundColor (fondo iniciales)</span>
        <input type="color" [(ngModel)]="backgroundColor" />
      </label>

      <label class="playground__field">
        <span>alt</span>
        <input type="text" [(ngModel)]="alt" />
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <common-avatar
          [imageUrl]="imageUrl || undefined"
          [initials]="initials"
          [size]="size"
          [backgroundColor]="backgroundColor"
          [alt]="alt"
        ></common-avatar>
      </div>

      <p class="playground__preview-title playground__preview-title--spaced">Todos los tamaños</p>
      <div class="playground__preview-box playground__preview-box--row">
        <common-avatar *ngFor="let s of sizes" [size]="s" [initials]="initials"></common-avatar>
      </div>
    </div>
  </div>
</section>
